<template>
    <ValidationProvider
      :vid="vid"
      :name="$attrs.name"
      :rules="rules"
      v-slot="{ valid, errors }"
    >
      <div class="p-field">
        <label v-if="$attrs.label" v-bind="$attrs">{{ $attrs.label }}</label>
        <Calendar
          v-model.trim="innerValue"
          v-bind="$attrs"
          autofocus
          autocomplete="off"
          :showIcon="true"
          :dateFormat="dateFormat"
          :class="{ 'p-invalid': errors[0] && !valid }"
          :showTime="showTime"
          :showSeconds="showSeconds"
          :locale="en"
        />
        <small id="inputLiveFeedback" class="p-invalid">
          {{ errors[0] }}
        </small>
      </div>
    </ValidationProvider>
  </template>

  <script>
  import { ValidationProvider } from "vee-validate";

  export default {
    components: {
      ValidationProvider
    },
    props: {
      vid: {
        type: String
      },
      rules: {
        type: [Object, String],
        default: ""
      },
      dateFormat: {
        type: String,
        default: "dd/mm/yy"
      },
      showTime: {
        type: Boolean,
        default: false
      },
      showSeconds: {
        type: Boolean,
        default: false
      },
      value: {
        type: null
      },
      en: {
        firstDayOfWeek: 0,
        dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
        monthNames: [ "January", "February", "March", "April", "May", "June", "Julio", "August", "September", "October", "November", "December" ],
        monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ],
        today: 'Today',
        clear: 'Clear',
        dateFormat: 'mm/dd/yy',
        weekHeader: 'Wk'
      }
    },
    data: () => ({
      innerValue: null
    }),
    watch: {
      // Handles internal model changes.
      innerValue(newVal) {
        this.$emit("input", newVal);
      },
      // Handles external model changes.
      value(newVal) {
        this.innerValue = newVal;
      }
    },
    created() {
      if (this.value) {
        this.innerValue = this.value;
      }
    }
  };
  </script>



// WEBPACK FOOTER //
// src/components/base/InputCalendar.vue